export const filterObjectProperties = (obj: Record<string, any>, guard: (entry: [string, any]) => boolean): Record<string, any> => {
    const entries = Object.entries(obj);

    return entries.reduce((acc, entry) => {
        if (guard && !guard(entry)) return acc;

        const [key, value] = entry;

        acc[key] = value;

        return acc;
    }, {} as Record<string, any>);
}

export const removeFalsyPropertiesFromObject = (obj: Record<string, any>): Record<string, any> => {
    return filterObjectProperties(obj, ([_, value]) => value !== null && value !== undefined);
}

export const formatForXWWWFormUrlencoded = (obj: Record<string, any>, uppercaseKey = true): URLSearchParams => {
    const formData = new URLSearchParams();
    const entries = Object.entries(obj);

    for (let i = 0; i < entries.length; i++) {
        const [k, value] = entries[i];
        const key = uppercaseKey ? k.charAt(0).toUpperCase() + k.slice(1) : k;

        if (typeof value === 'boolean') {
            formData.append(key, value.toString());
            continue;
        }

        if (typeof value === 'string') {
            formData.append(key, value);
            continue;
        }

        formData.append(key, String(value));
    }

    return formData;
}